import { useFormikContext } from "formik";
import styled from "@emotion/styled";

import { useFormData } from "../../../contexts/FormData";

import { useTheme } from "@emotion/react";

import { Card, CardHeader, CardContent, IconButton } from "@mui/material";

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from "../../../utils/utilities/CardComponents";

import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';

import { BasicFlex, LabelChip } from "../../../utils/Common";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import { capitalize, startCase } from "lodash";


const SummaryCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const WigList = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
`;

const WigLine = styled(BasicFlex)`
  padding: .3rem .4rem .3rem 1.6rem;
  border-top: 1px solid ${props => props.theme.colors.border};
`;

const WigInfo = styled(BasicFlex)`
  justify-content: flex-start;
  /* gap: 3.5rem; */
`;

const WigCode = styled.div`
  font-weight: 500;
  min-width: 10rem;
`

const WigActions  = styled.div`

`;

const Sidebar = () => {
  const { values } = useFormikContext();
  const { formValues, setFormValues } = useFormData() || {};

  const theme = useTheme();

  const st = values.shipment_type === "inbound" ? "Receive Consignment" : "Return";

  const basicBlock = [
    { header: "Shipment Type", info: startCase(st) },
    { header: "Shipment ID", info: values.shipment_num },
    { header: "Date Created", info: values.date_created, dataType: "date" },
  ];

  const vendorBlock = [
    { header: "Vendor", info: formValues.vendor_name },
  ];

  const itemBlock = [
    {header: "Num of Items", info: formValues.items.length, dataType: "number"},
    {header: "Total Qty", info: formValues.wigs.length, dataType: "number"},
  ];

  const removeItem = (id) => {
    setFormValues(oldObj => {
      // Create a new array with the item filtered out
      const filteredArray = oldObj.wigs.filter(item => item.wig_id !== id);
      // Return a new object with the updated array
      return {
        ...oldObj,
        wigs: filteredArray
      };
    });
  };

  return (
    <SummaryCards>
      <Card variant="outlined">
        <CardHeader title="Shipment Summary" action={<SummarizeRoundedIcon color="action" />} />
        <CardContent>
          <CardBlockContainer>
            <CardBlockHeader>Shipment Information</CardBlockHeader>
            {basicBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer />
            <CardBlockHeader>Vendor Information</CardBlockHeader>
            {vendorBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer />

            <CardBlockHeader>Content Summary</CardBlockHeader>
            {itemBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            
          </CardBlockContainer>
          {/* <pre>{JSON.stringify({ ...values, ...formValues }, null, 2)}</pre> */}
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardHeader title="List of Wigs" action={<LabelChip $bc={theme.colors.lightBg}>{formValues.wigs.length} Items</LabelChip>} />
        <WigList>
          {formValues.wigs.sort((a, b) => a.inventory_item_id - b.inventory_item_id).map((wig) => (
            <WigLine key={wig.wig_id}>
              <WigInfo>
                <WigCode>{wig.wig_id}</WigCode>
                <SimpleChip label={wig.sku} uc size="small" />
              </WigInfo>
              <WigActions>
                <IconButton size="small" onClick={() => removeItem(wig.wig_id)}><RemoveCircleOutlineRoundedIcon color="error" /></IconButton>
              </WigActions>
            </WigLine>
          ))}
        </WigList>
      </Card>
    </SummaryCards>
  );
};

export default Sidebar;